export let BI_ORIGIN = /*#__PURE__*/function (BI_ORIGIN) {
  BI_ORIGIN["ON_SITE"] = "on_site";
  return BI_ORIGIN;
}({});
export let BI_VIDEO_TYPE = /*#__PURE__*/function (BI_VIDEO_TYPE) {
  BI_VIDEO_TYPE["LIVE"] = "live";
  BI_VIDEO_TYPE["SCHEDULED"] = "scheduled";
  return BI_VIDEO_TYPE;
}({});
//# sourceMappingURL=bi.js.map